import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';

const Calendar = () => {
    const { t } = useLanguage();
    return (
        <div className="calendar-page">
            <div className="card">
                <div className="card-header"><h3 className="card-title">{t('Kalenda')}</h3></div>
                <div className="card-body">
                    <p>{t('Shows events: meetings, trainings, elections. (Placeholder)')}</p>
                </div>
            </div>
        </div>
    );
};

export default Calendar;
